// extracted by mini-css-extract-plugin
export default {"loader":"fyxXy","rotate-ltr":"oA1hI","rotateLtr":"oA1hI","rotate-rtl":"SpoaS","rotateRtl":"SpoaS"};